import { action } from 'typesafe-actions';
import { ECustomerTypeView } from '../user/types';
import {
  Types,
  ILongSteelOrdersResponse,
  EOrderTab,
  ITrackingFlatSteel,
  IOpenOrderData,
  IBilledOrderData,
  IBilledOrderTracking,
  IQCFileResponse,
  IDownloadNFEResponse,
  ITrackingLongSteel,
  ICgCertificateResponse
} from './types';

export const loadLongSteelOrdersFromLocalStorage = () =>
  action(Types.LOAD_LONG_STEEL_ORDERS_FROM_LOCAL_STORAGE, {});

export const loadLongSteelOrders = (
  states: string[],
  customerIds: string[],
  customerViewType: ECustomerTypeView,
  tab?: EOrderTab,
  startDate?: string,
  endDate?: string,
  needToLoadCustomer?: boolean
) =>
  action(Types.LOAD_LONG_STEEL_ORDERS, {
    states,
    customerIds,
    customerViewType,
    tab,
    startDate,
    endDate,
    needToLoadCustomer
  });

export const loadLongSteelOrdersSuccess = (
  ordersResponse: ILongSteelOrdersResponse
) => action(Types.LOAD_LONG_STEEL_ORDERS_SUCCESS, { ordersResponse });
export const loadLongSteelOrdersFailure = (error: unknown, bpError?: boolean) =>
  action(Types.LOAD_LONG_STEEL_ORDERS_FAILURE, { error, bpError });

export const loadTrackingFlatSteel = (openOrderItem: IOpenOrderData) =>
  action(Types.LOAD_TRACKING_FLAT_STEEL, { openOrderItem });
export const loadTrackingFlatSteelSuccess = (
  openOrderItem: IOpenOrderData,
  trackingFlatSteel: ITrackingFlatSteel
) =>
  action(Types.LOAD_TRACKING_FLAT_STEEL_SUCCESS, {
    openOrderItem,
    trackingFlatSteel
  });
export const loadTrackingFlatSteelFailure = (
  openOrderItem: IOpenOrderData,
  error: unknown
) => action(Types.LOAD_TRACKING_FLAT_STEEL_FAILURE, { openOrderItem, error });

export const loadTrackingLongSteel = (
  openOrderItemId: string,
  customerId: string,
  salesOrder: number,
  salesOrderItem: number
) =>
  action(Types.LOAD_TRACKING_LONG_STEEL, {
    openOrderItemId,
    customerId,
    salesOrder,
    salesOrderItem
  });
export const loadTrackingLongSteelSuccess = (
  openOrderItemId: string,
  trackingLongSteel: ITrackingLongSteel
) =>
  action(Types.LOAD_TRACKING_LONG_STEEL_SUCCESS, {
    openOrderItemId,
    trackingLongSteel
  });
export const loadTrackingLongSteelFailure = (
  openOrderItemId: string,
  error: unknown
) => action(Types.LOAD_TRACKING_LONG_STEEL_FAILURE, { openOrderItemId, error });

export const loadBilledOrderTracking = (billedOrderItem: IBilledOrderData) =>
  action(Types.LOAD_BILLED_ORDER_TRACKING, { billedOrderItem });
export const loadBilledOrderTrackingSuccess = (
  billedOrderItem: IBilledOrderData,
  billedOrderTracking: IBilledOrderTracking
) =>
  action(Types.LOAD_BILLED_ORDER_TRACKING_SUCCESS, {
    billedOrderItem,
    billedOrderTracking
  });
export const loadBilledOrderTrackingFailure = (
  billedOrderItem: IBilledOrderData,
  error: unknown
) =>
  action(Types.LOAD_BILLED_ORDER_TRACKING_FAILURE, { billedOrderItem, error });

export const loadQCFile = (billedOrderItem: IBilledOrderData) =>
  action(Types.LOAD_QC_FILE, { billedOrderItem });
export const loadQCFileSuccess = (
  billedOrderItem: IBilledOrderData,
  qcFileResponse: IQCFileResponse
) => action(Types.LOAD_QC_FILE_SUCCESS, { billedOrderItem, qcFileResponse });
export const loadQCFileFailure = (
  billedOrderItem: IBilledOrderData,
  error: unknown
) => action(Types.LOAD_QC_FILE_FAILURE, { billedOrderItem, error });
export const downloadQCFile = (billedOrderItem: IBilledOrderData) =>
  action(Types.DOWNLOAD_QC_FILE, { billedOrderItem });

export const loadNFFile = (billedOrderItem: IBilledOrderData) =>
  action(Types.LOAD_NF_FILE, { billedOrderItem });
export const loadNFFileSuccess = (
  billedOrderItem: IBilledOrderData,
  downloadNFEResponse: IDownloadNFEResponse
) =>
  action(Types.LOAD_NF_FILE_SUCCESS, { billedOrderItem, downloadNFEResponse });
export const loadNFFileFailure = (
  billedOrderItem: IBilledOrderData,
  error: unknown
) => action(Types.LOAD_NF_FILE_FAILURE, { billedOrderItem, error });
export const downloadNFFile = (billedOrderItem: IBilledOrderData) =>
  action(Types.DOWNLOAD_NF_FILE, { billedOrderItem });

export const loadShippingNoteFile = (billedOrderItem: IBilledOrderData) =>
  action(Types.LOAD_SHIPPING_NOTE_FILE, { billedOrderItem });
export const loadShippingNoteFileSuccess = (
  billedOrderItem: IBilledOrderData,
  downloadNFEResponse: IDownloadNFEResponse
) =>
  action(Types.LOAD_SHIPPING_NOTE_FILE_SUCCESS, {
    billedOrderItem,
    downloadNFEResponse
  });
export const loadShippingNoteFileFailure = (
  billedOrderItem: IBilledOrderData,
  error: unknown
) => action(Types.LOAD_SHIPPING_NOTE_FILE_FAILURE, { billedOrderItem, error });
export const downloadShippingNoteFile = (billedOrderItem: IBilledOrderData) =>
  action(Types.DOWNLOAD_SHIPPING_NOTE_FILE, { billedOrderItem });

export const clearOrdersState = (
  tab: EOrderTab,
  customerViewType?: ECustomerTypeView
) => action(Types.CLEAR_ORDERS_STATE, { tab, customerViewType });

export const cgQcRequest = (billedOrderItem: IBilledOrderData) =>
  action(Types.CG_QC_FILE_REQUEST, { billedOrderItem });

export const cgQcRequestSuccess = (
  billedOrderItem: IBilledOrderData,
  cgCqResponse: ICgCertificateResponse
) =>
  action(Types.CG_QC_FILE_REQUEST_SUCCESS, {
    billedOrderItem,
    cgCqResponse
  });

export const cgQcRequestFailure = (billedOrderItem: IBilledOrderData) =>
  action(Types.CG_QC_FILE_REQUEST_FAILURE, { billedOrderItem });

export const cgQcDownload = (billedOrderItem: IBilledOrderData) =>
  action(Types.CG_QC_FILE_DOWNLOAD, { billedOrderItem });
